module.exports = __webpack_public_path__ + "static/media/jcae2022_paper.13e6db72.gif";